"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _BoxConstants = require("./BoxConstants");

var _Styles = require("../utils/Styles");

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  align-self: ", ";\n  flex-basis: ", ";\n  flex-grow: ", ";\n  flex-shrink: ", ";\n  order: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var Box = _styledComponents.default.div.withConfig({
  displayName: "UIBox__Box",
  componentId: "sc-1wmdm00-0"
})(_templateObject(), function (props) {
  return _BoxConstants.ALIGN_SELF_OPTIONS[props.alignSelf];
}, function (props) {
  return (0, _Styles.toPx)(props.basis);
}, function (props) {
  return props.grow;
}, function (props) {
  return props.shrink;
}, function (props) {
  return props.order;
});

var UIBox = (0, _react.forwardRef)(function (_ref, ref) {
  var className = _ref.className,
      rest = (0, _objectWithoutProperties2.default)(_ref, ["className"]);
  return _react.default.createElement(Box, (0, _extends2.default)({}, rest, {
    className: (0, _classnames.default)('private-flex__child', className),
    ref: ref
  }));
});
UIBox.defaultProps = {
  alignSelf: 'auto',
  basis: 'auto',
  grow: 0,
  flexOrder: 0,
  shrink: 1
};
UIBox.propTypes = {
  alignSelf: _propTypes.default.oneOf(Object.keys(_BoxConstants.ALIGN_SELF_OPTIONS)),
  basis: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
  children: _propTypes.default.node,
  grow: _propTypes.default.number,
  shrink: _propTypes.default.number,
  order: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.oneOf(['inherit', 'initial', 'unset'])])
};
UIBox.displayName = 'UIBox';
var _default = UIBox;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.3722/js/layout/UIBox.js
// module id = 354
// module chunks = 5 6